<template>
  <router-view name="translationSetting" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "TranslationSetting",
};
</script>